import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { ionHomeOutline } from '@ng-icons/ionicons';
import { LanguageSwitcherComponent } from '../language-switcher/language-switcher.component';
@Component({
    selector: 'app-header',
    standalone: true,
    imports: [CommonModule, RouterModule, LanguageSwitcherComponent, NgIcon],
    providers: [provideIcons({ ionHomeOutline })],
    templateUrl: './header.component.html',
    styleUrl: './header.component.css',
})
export class HeaderComponent { } 